import Link from 'next/link'

import { useRouter } from 'next/router'

import { useAppSelector } from '../../../store/hooks'

import { LoginStatuses, selectedAuthStatus } from '../../../store/reducers/users'

import styles from './styles.module.scss'
import Icon1 from './icons/icon_1.svg'
import Icon2 from './icons/icon_2.svg'
import Icon3 from './icons/icon_3.svg'
import { useTranslation } from 'utils/use-translation'

export default function ExchangeGetStarted({ fromCurrency, toCurrency }) {
  const { t } = useTranslation()

  const authStatus = useAppSelector(selectedAuthStatus)
  const router = useRouter()

  const goToExchange = () => {
    if (authStatus === LoginStatuses.LOGIN) {
      router.push({
        pathname: '/account/exchange',
        query: {
          fromCurrency: fromCurrency.ticker.toUpperCase(),
          fromNetwork: fromCurrency.network.toUpperCase(),
          toCurrency: toCurrency.ticker.toUpperCase(),
          toNetwork: toCurrency.network.toUpperCase(),
        },
      })
    } else {
      router.push('/user/sign-in')
    }
  }

  return (
    <div className={styles.tiles}>
      <a className={styles.tile} onClick={goToExchange}>
        <img src={Icon1} alt="icon 1" />
        <h3>{t('swap')} {fromCurrency.name} {t('instantly')}</h3>
        <p>
          {t('convert')} {fromCurrency.ticker.toUpperCase()} {t('more_than_240')}
        </p>
      </a>

      <Link
        passHref
        href={
          fromCurrency.ticker.toLowerCase() === 'btc'
            ? `/wallet-coin/btc`
            : `/wallet/${fromCurrency.ticker.toLowerCase()}`
        }
      >
        <a className={styles.tile}>
          <img src={Icon2} alt="icon 3" />
          <h3>{t('store')} {fromCurrency.name} {t('safely')}</h3>
          <p>{t('manage_your')} {fromCurrency.name} {t('assets_more')}</p>
        </a>
      </Link>

      <Link passHref href={`/loans/${fromCurrency.ticker.toLowerCase()}`}>
        <a className={styles.tile}>
          <img src={Icon3} alt="icon 2" />
          <h3>{t('borrow_against_bone')} {fromCurrency.name}</h3>
          <p>{t('get_loan_against')} {fromCurrency.ticker.toUpperCase()} {t('without_credit_checks')}</p>
        </a>
      </Link>
    </div>
  )
}
